import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  callSizeData: {
    isMaxView: false,
    isMinView: false,
  },
};

const viewSlice = createSlice({
  name: "view",
  initialState,
  reducers: {
    setViewData: (state, action) => {
      state.callSizeData = action.payload;
    },
    removeViewData: (state) => {
      state.callSizeData = {
    isMaxView: false,
    isMinView: false,
  };
    },
  },
});

export const { setViewData, removeViewData } = viewSlice.actions;
export default viewSlice.reducer;